import { useState, useCallback } from "react";
import { saveDocumentConfigURL } from "../utils/ConstantsURL";
import { toastAlert } from "../utils/AlertContext";

export const useSaveDocumentConfig = (token) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const saveConfig = useCallback(
    async (documentId, changedFields) => {
      if (!documentId) {
        toastAlert("Se requiere un documentId para guardar la configuración", "warning");
        return false;
      }

      if (!changedFields || Object.keys(changedFields).length === 0) {
        toastAlert("No hay cambios que guardar", "info");
        return false;
      }

      setSaving(true);
      setError(null);

      try {
        const response = await fetch(saveDocumentConfigURL(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            documentId,
            config: changedFields,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.message ||
              `Error ${response.status}: No se pudo guardar la configuración del documento`
          );
        }

        const json = await response.json();

        if (!json?.success) {
          throw new Error(json?.message || "El servidor respondió con un error inesperado");
        }

        toastAlert("Configuración del documento guardada correctamente", "success");
        return true;
      } catch (err) {
        const message =
          err.message || "Error desconocido al guardar la configuración del documento";
        setError(message);
        toastAlert("Error al guardar la configuración del documento: " + message, "error");
        return false;
      } finally {
        setSaving(false);
      }
    },
    [token]
  );

  return { saveConfig, saving, error };
};
